<template>
    <div v-if="$route.name !== 'login' && $route.name !== 'register'"  class="navbar-container">
            
        <div class="navbar-box">
            <div class="navbar-row">
                <span class="navbar-element left">
                    <span class="back-btn hover" v-if="!($route.name === 'home' || $route.name === 'count')" @click="back()"><chill-icon class="medium-icon" icon="arrow_left"/></span>
                    <span class="back-btn hover" v-else-if="$route.name === 'count'" @click="showModal = true"><chill-icon class="medium-icon" icon="arrow_left"/></span>
                    <span v-else> (v 1.8.6) </span>

                </span>
                <span class="navbar-element center">
                    <router-link :to="{name: 'home'}" class="router-link-logo">
                        <div class="router-link">
                            <!-- <span class="router-link-text" >{{trans('chillchecklist')}}</span> -->
                            <img class="logo" src="@/assets/checklist-app.jpeg" alt="">
                        </div>
                    </router-link>
                    <!-- <img :to="{name: 'home'}" class="logo" src="@/assets/chillservices-logo.png" alt=""> -->
                </span>
                <span class="navbar-element right">
                    <span class="hover" v-if="$route.name === 'home'" @click="logout()">{{trans('logout')}}</span>
                    <span v-else> (v 1.8.6) </span>
                    <!-- <span class="hover" v-else>{{trans('version')}} beta 1.2</span> -->
                    <!-- <chill-icon class="dark new-tab-one-icon medium-icon" icon="info_circle"/> -->
                </span>
            </div>
            <div class="navbar-row-bottom">
                <div v-if="craft" class="nav-column" >
                    <span class="keyName">{{trans(path_title)}}</span>
                    <span class="keyValue">{{current_visit}} / {{trans(craft)}}</span>
                </div>
                <div v-else-if="current_visit" class="nav-column" >
                    <span class="keyName">{{trans(path_title)}}</span>
                    <span class="keyValue">{{current_visit}}</span>
                </div>
                <div v-if="betreiber" class="nav-column">
                    <span class="keyName">{{trans('Betreiber')}}</span>
                    <span class="keyValue">{{betreiber}}</span>
                </div>
                <div v-else-if="org" class="nav-column">
                    <span class="keyName">{{trans('firma')}}</span>
                    <span class="keyValue">{{trans(org)}}</span>
                </div>
            </div>
        </div>
        <modal
            v-if="showModal" 
            component="warningModal"
            :componentprops="{header: trans('warning_going_back_will_not_save_changes'), btnPrimary: trans('back'), btnSecondary: trans('dont_back')}"
            @disagree="showModal = false"
            @agree="count_back()"
        />
    </div>
</template>


<script>
	export default {
		name: 'chillNavbar',
        props: ['path_title', 'current_visit', 'craft', 'betreiber', 'org'],
		data() {
			return { 
                showModal: false
            }
		},
		beforeRouteLeave(){ },
		computed: { },
		methods: {
            count_back(){
                this.showModal = false
                this.$router.back()
            },
            back(){
                if(this.$route.name === 'visit'){
                    this.$router.push({ path: `/market/${this.$route.params.market_id}` });
                }else if(this.$route.name === 'done_visit'){
                    this.$router.push({ path: `/market/${this.$route.params.market_id}` });
                }else if(this.$route.name === 'checklist'){
                    this.$router.push({ path: `/visit/${this.$route.params.market_id}/${this.$route.params.visit_id}` });
                }
                else if(this.$route.name === 'market'){
                    this.$router.push({ path: "/" });
                }
                else{
                    this.$router.back()
                }
            }
        },
		mounted(){ }
	}
</script>

<style scoped lang="scss">
    span {
        font-size: 14px;
    }
    .navbar-container {
        z-index: 1;
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
        display: flex;
        height: 110px;
        /* border-bottom: solid #707070 1px; */
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        background-color: white;
        box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.16);
    }
    .navbar-box {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin: 10px auto;
        width: 86vw;
        max-width: 900px;
    }
    .navbar-row {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .nav-column {
        display: flex;
        flex-direction: column;
        min-width: 70px;
    }
    .navbar-element {
        flex: 1;
        margin: auto 0px;
    }
    .left {
        text-align: left;
    }
    .center {
        text-align: center;
    }
    .right {
        text-align: right;
    }
    .logo {
        width: 40px;
        height: auto;
    }
    .hover:hover {
        cursor: pointer;
    }
    .router-link {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    .router-link:focus {
        color: white;
    }
    .router-link-text {
        font-size: 13px;
        font-weight: 400;
        color: black;
    }
    .router-link-logo {
        text-decoration: none;
    }
    .keyName {
        font-size: 14px;
        font-weight: 300;
    }
    .keyvalue {
        font-size: 14px;
        font-weight: 400;
        color: #1B608C;
        min-height: 14px;
    }
    .back-btn {
        padding: 8px;
    }
    .navbar-row-bottom {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .home {
        .navbar-box {
            .navbar-row-bottom {
                display: flex;
                justify-content: space-between;
                justify-content: flex-end;
                width: 100%;
            }
        }
    }

</style>